export default "__VITE_ASSET__Bt_NUcla__"